import { render, staticRenderFns } from "./CouponRunWater.vue?vue&type=template&id=18df8f4b&scoped=true&"
import script from "./CouponRunWater.vue?vue&type=script&lang=js&"
export * from "./CouponRunWater.vue?vue&type=script&lang=js&"
import style0 from "./CouponRunWater.vue?vue&type=style&index=0&id=18df8f4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df8f4b",
  null
  
)

export default component.exports